import promiseMiddleware from './promise'
import analyticsMiddleware from './analytics'

import { getGraphQLClient } from 'data/dependencies'

// Like redux-thunk but with dependency injection.
const injectMiddleware = deps => ({ dispatch, getState }) => next => action => {
  const graphQLClient = getGraphQLClient(getState())

  if (typeof action === 'function') {
    const returnedAction = action({
      ...deps,
      dispatch,
      getState,
      graphQLClient,
    })
    if (returnedAction) {
      return next(returnedAction)
    }
  } else {
    return next(action)
  }
}

const configureMiddleware = (config, platformDeps, platformMiddleware) => {
  const middleware = [
    injectMiddleware({
      ...platformDeps,
      getUid: () => platformDeps.uuid.v4(),
      now: () => Date.now(),
    }),
    analyticsMiddleware,
    promiseMiddleware(),
    ...platformMiddleware,
  ]

  return middleware
}

export default configureMiddleware
